import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import addProduct from "../utils/addProducts.png";
import deleteIcon from "../utils/delete.png";
import Tooltip from "@mui/material/Tooltip";
import notAllowedSymbol from "../utils/notAllowedSymbol.svg";
import "../css/ItemSerchPopup.css"
import axios from "axios";
import ic_no_data from "../utils/ic_no_data_to_show.svg"

const ItemSearchPopupQuotation = ({
    handleInputChange,
    productEntries,
    productsInQuotationState,
    setF2PopupViewToggle,
    currentF2ItemForSearchPopup,
    setDuplicateItemCodeSnackbar,
    setProductsInQuotation,
    currentProductEntryRowId
}) => {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

    const [showLoadingSymbol, setShowLoadingSymbol] = useState(false)
    const timerSearch = useRef()
    const [productDataInfoPopup, setProductDataInfoPopup] = useState(null)

    const [currentViewingProduct, setCurrentViewingProduct] = useState(currentF2ItemForSearchPopup.itemCode)
    const [searchTextInItemSearchPopup, setSearchTextInItemSearchPopup] = useState(currentF2ItemForSearchPopup.itemCode)
    const [currentCheckedStatusOfThisItemFOC, setCurrentCheckedStatusOfThisItemFOC] = useState(false)
    const [currentCheckedStatusOfThisItem, setCurrentCheckedStatusOfThisItem] = useState(false)
    const [substituteStockArray, setSubstituteStockArray] = useState(null)
    const [locationStockArray, setLocationStockArray] = useState(null)


    console.log("currentF2ItemForSearchPopup productsInQuotationState ", currentF2ItemForSearchPopup, productsInQuotationState, currentProductEntryRowId)


    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            if (timerSearch.current) {
                clearTimeout(timerSearch.current)
            }

        };


    }, []);

    const fetchItemImage = (itemFilePath) => {
        if (!itemFilePath) return ""; // Handle missing image

        // Extract file name from the full path
        const extractedFileName = itemFilePath.split("BONDTIME_PRODUCT_IMG\\")[1];

        // Construct the correct URL for the image
        return `https://sunrise.dyndns-server.com:92/BONDTIME_PRODUCT_IMG/${extractedFileName}`;
    };

    const getLocationStock = (itemcode) => {

        let encodedItemCode = encodeURIComponent(itemcode)

        let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/LOCATIONSTOCK/${encodedItemCode}`

        console.log("location api ", apiUrl)

        axios.get(apiUrl).then((res) => {

            setLocationStockArray(res.data)
        }).catch((err) => {

        })
    }

    const getSubstituteArray = (itemcode) => {

        let encodedItemCode = encodeURIComponent(itemcode)
        axios.get(`${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/GETSUBSTITUTES/${encodedItemCode}`).then((res) => {

            setSubstituteStockArray(res.data)
        }).catch((err) => {

        })
    }


    const getStyleOfChip = () => {
        return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset"
    }

    useEffect(() => {

        console.log("useEffect currentViewingProduct", currentViewingProduct)



        if (currentViewingProduct) {
            getLocationStock(currentViewingProduct)
            getSubstituteArray(currentViewingProduct)
        }

    }, [currentViewingProduct])

    useEffect(() => {

        if (currentCheckedStatusOfThisItem) {
            handleInputChange(currentF2ItemForSearchPopup.id, "itemCustRef",
                "OPT"
            )
        } else {
            if (currentF2ItemForSearchPopup.itemCustRef != "" && currentF2ItemForSearchPopup.itemCustRef != "OPT") {
                handleInputChange(currentF2ItemForSearchPopup.id, "itemCustRef",
                    currentF2ItemForSearchPopup.itemCustRef
                )
            } else {
                handleInputChange(currentF2ItemForSearchPopup.id, "itemCustRef", ""
                )
            }

        }


    }, [currentCheckedStatusOfThisItem])

    useEffect(() => {

        if (currentCheckedStatusOfThisItemFOC) {
            handleInputChange(currentF2ItemForSearchPopup.id, "itemFoc",
                "FOC"
            )
        } else {
            if (currentF2ItemForSearchPopup.itemFoc != "" && currentF2ItemForSearchPopup.itemFoc != "FOC") {
                handleInputChange(currentF2ItemForSearchPopup.id, "itemFoc",
                    currentF2ItemForSearchPopup.itemFoc
                )
            } else {
                handleInputChange(currentF2ItemForSearchPopup.id, "itemFoc", ""
                )
            }

        }


    }, [currentCheckedStatusOfThisItemFOC])

    useEffect(() => {

        if (currentF2ItemForSearchPopup) {
            if (currentF2ItemForSearchPopup.itemCustRef == "OPT") {
                setCurrentCheckedStatusOfThisItem(true)
            }
            if (currentF2ItemForSearchPopup.itemFoc == "FOC") {
                setCurrentCheckedStatusOfThisItemFOC(true)
            }
        }

    }, [currentF2ItemForSearchPopup])

    const handleInputChangeInItemSearchPopupQuotation = (e) => {

        setSearchTextInItemSearchPopup(e.target.value)
    }

    const fetchItemDetails = async (itemCode) => {

        setShowLoadingSymbol(true)
        console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
        if (!itemCode) return;

        if (timerSearch.current) {
            clearTimeout(timerSearch.current)
        }
        timerSearch.current = setTimeout(async () => {
            try {
                const response = await fetch(
                    `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/Sitem/${encodeURIComponent(itemCode)}`
                );

                console.log("API response status:", response.status); // Log API response status

                const data = await response.json();
                console.log("API response data:", data); // Log response data
                setProductDataInfoPopup(data);
            } catch (error) {
                console.error("Error fetching item details:", error);
            } finally {
                setShowLoadingSymbol(false)
            }
        }, 500); // Delay API call to avoid excessive requests
    };

    useEffect(() => {

        if (searchTextInItemSearchPopup) {
            fetchItemDetails(searchTextInItemSearchPopup)
        } else {

            console.log("searchTextInItemSearchPopup empty")

            fetchItemDetails("-")
        }

    }, [searchTextInItemSearchPopup])

    const selectProduct = (setProductCode) => {

        console.log("code of select product", setProductCode);

        const isDuplicate = productEntries.some(
            (product) => product.itemCode === setProductCode
        );
        if (isDuplicate) {
            // alert('this item already exists')
            setDuplicateItemCodeSnackbar(true);

            return;
        }

        const selectedProduct = productDataInfoPopup.find(
            (product) => product.Code === setProductCode
        );

        if (selectedProduct) {
            setProductsInQuotation((prevEntries) =>
                prevEntries.map((entry) =>
                    entry.id === currentProductEntryRowId
                        ? {
                            ...entry,
                            itemCode: selectedProduct.Code,
                            itemDescription: selectedProduct.Description,
                            itemImage: selectedProduct.Imagepath,
                            // itemUnit: selectedProduct.unit,
                            itemUnit: "PCS",
                            itemCurrentStock: selectedProduct.Stick, // Adjust according to your product data
                            itemPrice: selectedProduct.SelPrice, // Adjust according to your product data
                            itemAmount: selectedProduct.SelPrice * entry.itemQuantity, // Example calculation
                            isSelectedItemCodeCorrect: true, // Example calculation
                        }
                        : entry
                )
            );
        }
    };


    return (
        <div className="ItemSearchPopup-root-container p-10">

            <div className="bg-white p-4 h-full">

                <div className="flex justify-between">
                    <h2>Item Search</h2>

                    <button onClick={() => setF2PopupViewToggle(false)} className="bg-red-400 text-white px-4 py-0 rounded">Close</button>
                </div>

                <div style={{ height: "95%" }} className="mt-2  w-full flex">

                    <div style={{ height: "100%", width: "75%" }} className="left-box  p-2 ">

                        <div style={{ height: "99%" }} >

                            <input
                                className="w-full"
                                type="text"
                                value={searchTextInItemSearchPopup}
                                onChange={(e) =>
                                    handleInputChangeInItemSearchPopupQuotation(e)
                                } />
                            <div style={{ height: "94%", overflowY: "scroll" }} className="w-full bg-gray-100  scrollbar-thin shadow-lg  border border-gray-300">

                                {
                                    showLoadingSymbol && <div className="flex justify-center p-4">
                                        <div role="status">
                                            <svg aria-hidden="true" class="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                            </svg>
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                }
                                {productDataInfoPopup
                                    ?.filter((product) => product.Code) // Filter matching products
                                    ?.map((product, index) => (
                                        <div
                                            onClick={() => setCurrentViewingProduct(product.Code)}
                                            key={index}
                                            className={currentViewingProduct == product.Code ? "px-1  py-1 border bg-blue-200 " : "px-1  py-1 border bg-white hover:bg-gray-200"}
                                        >

                                            <p className="flex justify-between">
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <img
                                                        src={fetchItemImage(product.Imagepath
                                                        )}
                                                        alt="Product"
                                                        className="w-20 h-20 p-1"
                                                    />
                                                    <div>
                                                        <p className="font-semibold">{product.Code}</p>
                                                        <p className="text-xs text-gray-500">
                                                            {product.Description}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <button className="bg-blue-500 border-0 text-white  px-4 border" onClick={() => selectProduct(product.Code)}>Select</button>
                                                </div>
                                            </p>

                                            <div>
                                                <span className={getStyleOfChip()}>
                                                    Group: {product.Group}
                                                </span>
                                                <span className={getStyleOfChip()}>
                                                    Subgroup: {product.Sgroup}
                                                </span>
                                                <span className={getStyleOfChip()}>
                                                    Stock: {product.Stock}
                                                </span>
                                                <span className={getStyleOfChip()}>
                                                    Ord Pending: {product.Ord_Pend}
                                                </span>
                                                <span className={getStyleOfChip()}>
                                                    PO Pending: {product.Po_Pend}
                                                </span>
                                                <span className={getStyleOfChip()}>
                                                    Selprice: {product.SelPrice}
                                                </span>
                                            </div>

                                            {/* <p className="text-xs text-gray-500">
                                {product.Imagepath}
                              </p> */}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "25%" }} className="right-box  p-2">


                        <div className="px-2 pt-2">
                            <span>{currentViewingProduct}</span>
                            <div>
                                <button
                                    onClick={() => setCurrentCheckedStatusOfThisItemFOC(prev => !prev)}>
                                    <input
                                        type="checkbox"
                                        className="rounded border border-sm shadow me-2"
                                        checked={currentCheckedStatusOfThisItemFOC}
                                    />Mark as FOC
                                </button>
                                <button className="ms-2"
                                    onClick={() => setCurrentCheckedStatusOfThisItem(prev => !prev)}>
                                    <input
                                        type="checkbox"
                                        className="rounded border border-sm shadow me-2"
                                        checked={currentCheckedStatusOfThisItem}
                                    />mark as substitute
                                </button>
                            </div>
                        </div>

                        <div className="location-box mt-2" style={{ height: "46%", backgroundColor: "#d5d5d5" }}>

                            <h5 className="p-3">Location</h5>
                            <div className="px-3" style={{ overflowY: "scroll", height: "70%" }}>
                                {
                                    locationStockArray ?
                                        locationStockArray.length > 0 ?
                                            locationStockArray?.map((item) => {
                                                return (
                                                    <div style={{ margin: "2px", backgroundColor: "#f5f5f5" }}>
                                                        <div>
                                                            <span style={{ padding: "2px" }}>LOC {item.LOC}</span>
                                                            <span style={{ marginLeft: "10px", padding: "2px" }}>Qty {item.Qty}</span>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <img style={{ width: "90px" }} src={ic_no_data} />
                                                <p className="p-2 text-slate-500" > No data to show</p>
                                            </div>
                                        :
                                        <p>No Data</p>
                                }
                            </div>
                        </div>
                        <div className="substitute-box mt-2" style={{ height: "46%", backgroundColor: "#d5d5d5" }}>
                            <h5 className="p-3">Subsitute Items</h5>
                            <div style={{ overflowY: "scroll", height: "70%" }}>
                                {
                                    substituteStockArray ?

                                        substituteStockArray.length > 0 ?
                                            substituteStockArray?.map((item) => {
                                                return (
                                                    <div style={{ margin: "2px" }}>
                                                        <div style={{ margin: "2px", backgroundColor: "#f5f5f5" }}>
                                                            <p style={{ padding: "2px" }}>LOC {item.Substitutes}</p>
                                                            <p style={{ padding: "2px" }}>Qty {item.Qty ? item.Qty : "--"}</p>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <img style={{ width: "90px" }} src={ic_no_data} />
                                                <p className="p-2 text-slate-500" > No data to show</p>
                                            </div>
                                        :
                                        <p>No Data</p>
                                }
                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div >
    );
};

export default ItemSearchPopupQuotation;
